import axios from 'config/api';
import { FETCH_CLIPPINGS_SUCCESS } from 'config/constants';

export function fetchClippingObjects(text) {
  return axios.post('/user/clippings/events/', { text }).then(({ data }) => {
    return {
      type: FETCH_CLIPPINGS_SUCCESS,
      data: data,
    };
  });
}

export function fillSelects(text, source) {
  if (source) {
    text += '/' + source;
  }
  return axios.get(`/${text}`).then(({ data }) => {
    if (text === 'actions') {
      data.sort(compare);
    }
    return {
      type: FETCH_CLIPPINGS_SUCCESS,
      data: data,
    };
  });
}

function compare(a, b) {
  const actionA = a.action.toUpperCase();
  const actionB = b.action.toUpperCase();

  let comparison = 0;
  if (actionA > actionB) {
    comparison = 1;
  } else if (actionA < actionB) {
    comparison = -1;
  }

  return comparison;
}
